import React from 'react';
import OttoAlive from './OttoAlive';
import './otto.css';

// Homepage intro card (first-run, dismissible). Otto (Default) with a
// gentle idle bob beside a speech bubble. Copy is locked to the brief.
// "Show me around" can launch the onboarding tour; "Maybe later"
// dismisses. Admin/internal only.
export default function OttoIntroCard({ onShowAround, onDismiss }) {
  return (
    // Dark bar — matches the admin sidebar surface (#101113) so Otto's
    // home reads as part of the same shell chrome.
    <div className="relative bg-surface-sidebar border border-white/[0.06] rounded-card shadow-card p-6 flex items-center gap-5 mb-8">
      <div className="flex-shrink-0">
        {/* CAPTAIN, and the only in-app surface that gets him outside a
            milestone. A formal welcome from the person in charge is exactly
            what a first-run screen is, and at once-per-user it cannot dilute
            the milestone signal however the uniform is read.
            (docs/otto-captain-uniform.md §4 — the one it argued hardest for.)

            The tour he launches stays EVERYDAY on purpose: the greeting is
            formal, the guidance is friendly, and a tour is many screens —
            which is where repetition would start spending the uniform.

            He keeps the whole alive layer: ambient idles, hover-perk,
            click-wave, cursor-follow. `play="wave"` greets on appearance so he
            arrives waving rather than posing. */}
        <OttoAlive size={92} variant="captain" play="wave" />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="font-['Metropolis'] text-[15px] font-extrabold text-white">
          Hello, I'm Captain Otto — your Pilot Owl
        </h3>
        <p className="font-['Metropolis'] text-[13px] text-sb-text leading-relaxed mt-1.5 max-w-[62ch]">
          I'll keep an eye on your briefs and help you get the suppliers on board. You'll see me pop up around Supply Pilot.
        </p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="absolute right-3 top-3 text-sb-muted hover:text-white text-lg leading-none bg-transparent border-0 cursor-pointer">
        ×
      </button>
    </div>
  );
}
